module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy4"
    }
  }, [_c('rect', {
    attrs: {
      "id": "boy4_bag_3",
      "width": "45",
      "height": "61",
      "x": "6130",
      "y": "284",
      "fill": "#BC9555",
      "rx": "22.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_hand",
      "fill": "#E2B56C",
      "d": "M6121.95 350.92c-.15 1.4-1.1 2.1-2.13 3.67-1.2 1.82-1.42 5.32-2.82 8.14.25.7 2.3-.35 2.8-1.5.5-1.13.9-2.06 1.06-2.34.16-.3.5-.23.57.07.08.3-.67 10.6-.5 11.13.16.53 1.32.68 1.58.18s1.03-8.64 1.15-8.85c.12-.2.37-.07.47.06.1.1-.95 8.78-.8 9.12.14.35 1.35.43 1.5.17.17-.26 1.06-8.92 1.2-9.1.16-.18.43-.13.52.06.1.2-1.03 8.5-.87 8.87.15.38 1.32.52 1.47.17.14-.36 1.2-8.72 1.33-8.82.12-.1.28-.1.37.04.1.12-.4 6.4-.25 6.76.15.36 1.02.54 1.2.13.17-.4 1.05-15.73 1.15-16.58.33-2.82-.9-5.94-4-6.28-3.07-.35-4.68 1.85-5 4.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_arm_bottom",
      "fill": "#A98448",
      "d": "M6130.57 316.04c3.94.42 6.8 4.04 6.4 8.08l-.05.3-3.8 26.5c-.2 1.3-1.35 2.2-2.63 2.07l-7.36-.8c-1.27-.14-2.22-1.28-2.14-2.6l1.65-26.7c.25-4.06 3.66-7.14 7.62-6.9l.3.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_arm_top",
      "fill": "#A98448",
      "d": "M6132.6 289.04c3.93.42 6.77 4 6.36 7.98l-2.73 26.48c-.42 4-3.92 6.88-7.84 6.46-3.93-.42-6.77-4-6.36-7.98l2.73-26.48c.42-4 3.92-6.88 7.84-6.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_shoe_4",
      "fill": "#91713D",
      "d": "M6129.5 434h12.5v14h-27c.23-4 2.1-6.34 5.6-7 3.5-.66 6.47-3 8.9-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_shoe_3",
      "fill": "#A98448",
      "d": "M6142 446v2h-27c.08-.92.17-1.6.26-2H6142z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_right_shoe_2",
      "fill": "#A98448",
      "points": "6130 439.931957 6128.97303 441 6125 438.816129 6126.26134 438"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_right_shoe_1",
      "fill": "#A98448",
      "points": "6132 437.8 6131.01991 439 6127 437.095241 6128.02091 436"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_leg_bottom",
      "fill": "#BC9555",
      "d": "M6135 384c4.42 0 8 3.58 8 8v42h-16v-42c0-4.42 3.58-8 8-8z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_right_leg_top",
      "width": "16",
      "height": "57",
      "x": "6127",
      "y": "340",
      "fill": "#BC9555",
      "rx": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_shoe_4",
      "fill": "#91713D",
      "d": "M6150.5 434h12.5v14h-27c.23-4 2.1-6.34 5.6-7 3.5-.66 6.47-3 8.9-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_shoe_3",
      "fill": "#A98448",
      "d": "M6163 446v2h-27c.08-.92.17-1.6.26-2H6163z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_left_shoe_2",
      "fill": "#A98448",
      "points": "6152 439.931957 6150.97303 441 6147 438.816129 6148.26134 438"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_left_shoe_1",
      "fill": "#A98448",
      "points": "6154 437.8 6153.01991 439 6149 437.095241 6150.02091 436"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_leg_bottom",
      "fill": "#BC9555",
      "d": "M6157 383c4.42 0 8 3.58 8 8v43h-16v-43c0-4.42 3.58-8 8-8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_leg_top",
      "fill": "#BC9555",
      "d": "M6157 340c4.42 0 8 3.58 8 8v41c0 4.42-3.58 8-8 8s-8-3.58-8-8v-41c0-4.42 3.58-8 8-8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_hip",
      "fill": "#BC9555",
      "d": "M6127 342h38c0 10.5-8.5 19-19 19s-19-8.5-19-19z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_zipper",
      "fill": "#A98448",
      "d": "M6136 342h5v14c-4.7-3.02-5-6.2-5-14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_torso",
      "fill": "#91713D",
      "d": "M6129.38 292.42c3.52-9.64 27.63-7.4 32.15 0 6.3 10.28 4.3 47.86 3.67 48.87-5.63 9-35.6 5.75-39.74 1.2-1.78-1.96 2.02-44.9 3.92-50.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_bag_2",
      "fill": "#D3A862",
      "d": "M6153.63 287c1.56 0 5 1.74 5.32 3.2 0 2.03.12 35.65 0 37.8-11.52-4.2-12.68-35.78-5.32-41z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_bag_1",
      "fill": "#D3A862",
      "d": "M6129.08 293.93c.8-2.6 3.56-5.62 5.92-5.93-3.05 10.9-6.7 25.02-9 35 .46-8.34 2.02-25.58 3.08-29.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_hand",
      "fill": "#E2B56C",
      "d": "M6156.95 351.4c0 1.42-.94 2.2-1.85 3.88-1.05 1.94-.93 5.44-2.1 8.4.34.67 2.36-.6 2.77-1.8.4-1.2.72-2.15.86-2.45.14-.3.5-.28.6 0 .12.3.4 10.6.62 11.1.22.5 1.45.52 1.67 0 .2-.53.18-8.68.28-8.9.1-.22.38-.1.5 0 .1.12-.1 8.82.1 9.15.18.32 1.45.27 1.6 0 .13-.27.18-8.95.32-9.15.13-.2.42-.17.53 0 .12.18-.2 8.54 0 8.9.2.35 1.43.36 1.55 0 .1-.37.36-8.78.48-8.9.12-.12.28-.1.4 0 .1.1.23 6.4.43 6.73.2.34 1.14.42 1.28 0 .14-.42-.52-15.72-.5-16.57.06-2.84-1.56-5.8-4.8-5.8-3.25 0-4.7 2.36-4.73 5.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_arm_bottom",
      "fill": "#A98448",
      "d": "M6162 317c3.87 0 7.02 3.14 7.02 7.02v.27l-1 24.9c-.1 2.68-2.3 4.8-5 4.8h-2.05c-2.7 0-4.9-2.12-5-4.8l-.98-24.9c-.16-3.88 2.85-7.14 6.72-7.3h.28z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_left_arm_top",
      "width": "14",
      "height": "41",
      "x": "6155",
      "y": "290",
      "fill": "#A98448",
      "rx": "7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_neck",
      "fill": "#E2B56C",
      "d": "M6139.55 282.4c.4 2.38.56 3.8-.55 5.1l3.82 6.5c3.76-3.98 5.82-6.14 6.18-6.5-1-1.34-1.07-2.44-.47-5.1-.74-1.9-7.95-1.84-8.98 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_face",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M6161.25 264.6c1-.6 2.46-1.38 4.1 0 1.4 1.18.35 5.82-1.55 8.4-1.88 2.53-4.93 3.06-6.13 2.1-2.54 5.83-9 8.94-13.3 8.9-11.55-.1-16.37-12.08-16.37-22.02 0-15.7 6.12-20.98 16.37-20.98 9.2-.05 19.4 4.93 16.88 23.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_mouth_bottom",
      "fill": "#D3A862",
      "d": "M6138.18 279h6.7c.7 0-1.8 1-4.03 1-2.24 0-3.3-1-2.67-1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_mouth_top",
      "fill": "#D3A862",
      "d": "M6137.23 279h8.62c.9 0-2.3-2-5.2-2-2.86 0-4.22 2-3.42 2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_nose",
      "fill": "#D3A862",
      "d": "M6140.1 264.77c.2-1 2.4-1.06 2.5 0 .12 1.06.82 6.62.02 7.6-.8 1-3.18.66-3.55 0-.37-.65.84-6.6 1.03-7.6z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_glasses_3",
      "width": "10",
      "height": "8",
      "x": "6144",
      "y": "263",
      "fill": "#FBD79E",
      "stroke": "#91713D",
      "rx": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_glasses_2",
      "stroke": "#91713D",
      "d": "M6139.24 266.5h5.04",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_glasses_1",
      "width": "10",
      "height": "8",
      "x": "6128",
      "y": "263",
      "fill": "#FBD79E",
      "stroke": "#91713D",
      "rx": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_right_brow",
      "fill": "#91713D",
      "d": "M6136.98 260.05c-.24-1.36-7.82-1.38-7.97-.17-.14 1.22 1.45.64 3.54.87 2.1.23 4.68.66 4.44-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_left_brow",
      "fill": "#91713D",
      "d": "M6146.02 260.05c.24-1.36 7.82-1.38 7.97-.17.14 1.22-1.45.64-3.54.87-2.1.23-4.68.66-4.44-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy4_hair",
      "fill": "#A98448",
      "d": "M6135.15 249.94c.66 5 4.5 11.15 5.88 12.6.3-.95.3-4.25 0-5.4.84 1 3.12 4.43 3.82 5.92.38-1.84.62-4.48.38-5.9 1.23 1.42 3.3 4.22 4.1 5.9.64-1.68 1.3-3.58 1.3-4.48 1.02 1.05 4.08 5.3 5.1 6.6.3-1.6.3-2.63.3-3.8.74.9 2.2 3.82 2.84 5.5.6-1.06 1.02-2.53 1.02-4.7.8 1.64 1 3.96 1.3 5.82.73-1.04 1.1-2.42 1.43-3.25.46.68 1.43 2.04 2.26 3 .66-4 .5-9.17-.84-11.93 1.34.8 2.82 1.33 3.94 1.33-3.95-4.65-2.9-7.9-8.16-11.5 1.68.18 4.02.76 5.56.58-2.05-1.92-7.66-4.4-9.67-5.07-2-.65-6.05-2.44-10.88-2.12-4.82.3-6.92 1.82-8.25 3.5-2.47-.68-4.98-1.87-6.27-2.56.15.93.95 2.57 1.82 3.74-3.77 1.22-4.34 6.73-9.15 10.48.92.3 2.46.1 3.7-.3-.8 1.24-2.9 4.68-2.53 7.1.7-1.04 1.88-2.42 2.52-2.7-.28 1.47-.6 3.63.4 5.64 1.08-3.93 3.92-11.1 8.05-14z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8f0548","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/boyFour.vue
// module id = 653
// module chunks = 1